import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Call from "@/pages/Call";
import History from "@/pages/History";
import Admin from "@/pages/Admin";
import Billboards from "@/pages/Billboards";
import Marketing from "@/pages/Marketing";
import VoiceStudio from "@/pages/VoiceStudio";
import MarketLanding from "@/pages/MarketLanding";

function App() {
  return (
    <div className="App cg-page-bg min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/call" element={<Call />} />
          <Route path="/history" element={<History />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/billboards" element={<Billboards />} />
          <Route path="/admin/marketing" element={<Marketing />} />
          <Route path="/admin/voice" element={<VoiceStudio />} />
          <Route path="/m/:slug" element={<MarketLanding />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
